<div [formGroup]="formRef">
  <input
    type="text"
    placeholder="Seleccione"
    class="form-control datepicker pointer"
    bsDatepicker
    #dp="bsDatepicker"
    [formControlName]="controlName"
    readonly
    (bsValueChange)="onDateSelected(dp)"
    customTodayClass="today-class"
    [bsConfig]="bsConfig"
  />
  <i class="glyphicon glyphicon-calendar form-control-feedback"></i>
</div>
